export class ExecuteTemplateActionSettings {
    static $inject = ['init'];
    constructor(init) {
        this.inputVariables = [];
        Object.assign(this, init);
    }
}
